import { Box, Tooltip, Typography } from "@mui/material"
import type { FC } from "react"

import { ProductTestStatus } from "@/graphql/codegen/graphql"
import {
  GoodsReceiptPalletTestStatusToIconMap,
  GoodsReceiptPalletTestStatusToLabelMap,
} from "@/screens/WarehouseReceiving/constants"

interface GoodsReceiptLotTestStatusIndicatorProps {
  status: ProductTestStatus | null | undefined
}

export const GoodsReceiptLotTestStatusIndicator: FC<GoodsReceiptLotTestStatusIndicatorProps> = ({ status }) => {
  const icon = status
    ? GoodsReceiptPalletTestStatusToIconMap.get(status)
    : GoodsReceiptPalletTestStatusToIconMap.get(ProductTestStatus.DirectShip)
  const label = status
    ? GoodsReceiptPalletTestStatusToLabelMap.get(status)
    : GoodsReceiptPalletTestStatusToLabelMap.get(ProductTestStatus.DirectShip)

  return (
    <Tooltip
      title={
        <Box>
          <Typography variant='body2' className='font-semibold'>
            {label}
          </Typography>
        </Box>
      }
      arrow
      placement='top'
      enterTouchDelay={0}
    >
      <span className='inline-flex'>{icon}</span>
    </Tooltip>
  )
}
